import { JSX } from "react";

export const NotificationsActive = (): JSX.Element => {
    return (
        <svg
            width="35"
            height="35"
            viewBox="0 0 35 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.5 29.7631V26.2718H7V14.0524C7 11.6376 7.72917 9.4919 9.1875 7.61534C10.6458 5.73878 12.5417 4.50956 14.875 3.92768V2.70574C14.875 1.97839 15.1302 1.36014 15.6406 0.850998C16.151 0.341854 16.7708 0.0872818 17.5 0.0872818C18.2292 0.0872818 18.849 0.341854 19.3594 0.850998C19.8698 1.36014 20.125 1.97839 20.125 2.70574V3.92768C22.4583 4.50956 24.3542 5.73878 25.8125 7.61534C27.2708 9.4919 28 11.6376 28 14.0524V26.2718H31.5V29.7631H3.5ZM17.5 35C16.5375 35 15.7135 34.6581 15.0281 33.9744C14.3427 33.2907 14 32.4688 14 31.5087H21C21 32.4688 20.6573 33.2907 19.9719 33.9744C19.2865 34.6581 18.4625 35 17.5 35ZM0 14.0524C0 11.143 0.648958 8.47361 1.94688 6.04426C3.24479 3.61492 4.9875 1.60017 7.175 0L9.23125 2.79302C7.48125 4.07315 6.08854 5.68786 5.05312 7.63716C4.01771 9.58645 3.5 11.7249 3.5 14.0524H0ZM31.5 14.0524C31.5 11.7249 30.9823 9.58645 29.9469 7.63716C28.9115 5.68786 27.5188 4.07315 25.7688 2.79302L27.825 0C30.0125 1.60017 31.7552 3.61492 33.0531 6.04426C34.351 8.47361 35 11.143 35 14.0524H31.5Z"
                fill="#E67A01"
            />
        </svg>
    );
};
